/**
 * Utilitaire générique de gestion des templates de messages.
 *
 * Permet de remplacer des variables de la forme {{variable}} dans un texte
 * par les valeurs fournies. Utilisable pour n'importe quel canal
 * (WhatsApp, SMS, email...) et n'importe quelle entité (commande, client, livreur...).
 */

/**
 * Remplace toutes les variables {{cle}} d'un texte par leur valeur.
 *
 * @param {string} texte - Texte contenant des variables au format {{cle}}
 * @param {Object} variables - Dictionnaire { cle: valeur }
 * @param {string} [valeurParDefaut=''] - Valeur utilisée quand la variable est absente/vide
 * @returns {string} Texte avec les variables remplacées
 */
export const appliquerVariables = (texte, variables = {}, valeurParDefaut = '') => {
  if (!texte) return '';

  // Recherche de tous les motifs {{ cle }} (espaces autorisés autour de la clé)
  return texte.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (correspondance, cle) => {
    const valeur = variables[cle];
    // On considère null, undefined et chaîne vide comme "non renseigné"
    if (valeur === null || valeur === undefined || valeur === '') {
      return valeurParDefaut;
    }
    return String(valeur);
  });
};

/**
 * Extrait la liste des noms de variables utilisées dans un texte.
 * Utile pour afficher à l'utilisateur les variables disponibles/utilisées.
 *
 * @param {string} texte - Texte contenant des variables au format {{cle}}
 * @returns {string[]} Liste des noms de variables (sans doublon)
 */
export const extraireVariables = (texte) => {
  if (!texte) return [];

  const correspondances = texte.match(/\{\{\s*([\w.]+)\s*\}\}/g) || [];

  // Nettoyage des accolades/espaces puis suppression des doublons
  return [...new Set(
    correspondances.map((motif) => motif.replace(/[{}]/g, '').trim())
  )];
};

// Export groupé des utilitaires de template
const messageTemplate = { appliquerVariables, extraireVariables };

export default messageTemplate;
